import { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import Button from "../../../../components/button/Button";
import DisplayContainer from "../../../../components/displayContainer/DisplayContainer";
import AuthTextInput from "../../../../components/inputs/authTextInput/AuthTextInput";
import SelectInput from "../../../../components/inputs/selectInput/SelectInput";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import { showConfirmationModal } from "../../../../features/confirmationModal/ConfirmationModalSlice";
import useAssignableRoles from "../../../../hooks/useAssignableRoles";
import styles from "./editEmployee.module.css";

const EditEmployee = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const {
    name: fetchedName,
    role: fetchedRole,
    adminId: fetchedAdminId,
  } = location.state;

  const [adminName, setAdminName] = useState(fetchedName);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfrimPassword] = useState("");
  const [role, setRole] = useState(fetchedRole);

  const [adminNameEligibility, setAdminNameEligibility] = useState(true);
  const [passwordEligibility, setPasswordEligibility] = useState(false);

  const manageableRoles = useAssignableRoles();

  const handleAdminUpdate = (updateType) => {
    if (updateType === "admin") {
      if (adminNameEligibility) {
        dispatch(
          showConfirmationModal({
            message: "هل انت متاكد من التعديل على الموظف ؟",
            data: {
              adminId: fetchedAdminId,
              adminData: { name: adminName, role },
            },
            actionType: "updateAdmin",
          })
        );
      }
    } else {
      if (passwordEligibility && password === confirmPassword) {
        dispatch(
          showConfirmationModal({
            message: "هل انت متاكد من التعديل على الموظف ؟",
            data: {
              adminId: fetchedAdminId,
              adminData: { password },
            },
            actionType: "updateAdmin",
          })
        );
      }
    }
  };

  return (
    <div className={styles.container}>
      <TextWrapper textStyle="textTitle">{`التعديل على الموظف : ${fetchedName}`}</TextWrapper>
      <div className={styles.editEmployeeWrapper}>
        <DisplayContainer>
          <div className={styles.inputWrapper}>
            <TextWrapper textStyle="textMid">اسم الموظف</TextWrapper>
            <AuthTextInput
              height="50px"
              width="400px"
              borderRadius="10px"
              placeholder="اسم الموظف"
              bgColor={"grey"}
              regex={/^.{5,}$/}
              value={adminName}
              setValue={setAdminName}
              setEligibility={setAdminNameEligibility}
            />
          </div>
          <div className={styles.inputWrapper}>
            <TextWrapper textStyle="textMid">اختيار الوظيفه</TextWrapper>
          </div>
          <SelectInput
            setValue={setRole}
            value={role}
            placeHolder={"اختيار الوظيفه"}
          >
            {manageableRoles.map((item, index) => (
              <option value={item} key={index}>
                {item}
              </option>
            ))}
          </SelectInput>
          <div className={styles.inputWrapper}>
            <TextWrapper textStyle="textMid">كلمة السر الجديده</TextWrapper>
            <AuthTextInput
              height="50px"
              width="400px"
              borderRadius="10px"
              placeholder="كلمة السر الجديده"
              bgColor={"grey"}
              regex={/^.{8,}$/}
              value={password}
              setValue={setPassword}
              setEligibility={setPasswordEligibility}
              isPassword={true}
            />
          </div>
          <div className={styles.inputWrapper}>
            <TextWrapper textStyle="textMid">
              تأكيد كلمة السر الجديده
            </TextWrapper>
            <AuthTextInput
              height="50px"
              width="400px"
              borderRadius="10px"
              placeholder=" تأكيد كلمة السر الجديده"
              bgColor={"grey"}
              value={confirmPassword}
              setValue={setConfrimPassword}
              isPassword={true}
            />
          </div>
          <div className={styles.updateAdminBtnsWrapper}>
            <Button
              size="bigSize"
              variant="blackVariant"
              functionallity={() => handleAdminUpdate("admin")}
            >
              <TextWrapper textStyle="textMid">التعديل على الموظف</TextWrapper>
            </Button>
            <Button
              size="bigSize"
              variant="blackVariant"
              functionallity={handleAdminUpdate}
            >
              <TextWrapper textStyle="textMid">
                تغيير كلمة سر الموظف
              </TextWrapper>
            </Button>
          </div>
        </DisplayContainer>
      </div>
    </div>
  );
};

export default EditEmployee;
